<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">Edit Giftcard</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a></li>
                            <li class="breadcrumb-item">
                                <Link :href="route('admin.giftcards.index')">Giftcards</Link>
                            </li>
                            <li class="breadcrumb-item active">Edit Recipient</li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-body">
            <section class="card">
                <div class="card-body">
                    <form @submit.prevent="save">
                        <div class="row">
                            <div class="col-12 col-md-6">
                                <div class="form-group">
                                    <label>Giftcard Code</label>
                                    <input type="text" class="form-control" :value="giftcard.code" disabled>
                                </div>
                            </div>
                            <div class="col-12 col-md-6">
                                <div class="form-group">
                                    <label>Recipient Name</label>
                                    <input type="text" class="form-control" :value="giftcard.recipient_name" disabled>
                                </div>
                            </div>
                            <div class="col-12 col-md-6">
                                <div class="form-group">
                                    <label>Amount</label>
                                    <input type="text" class="form-control" :value="formatAmount(giftcard.amount)" disabled>
                                </div>
                            </div>
                            <div class="col-12 col-md-6">
                                <div class="form-group">
                                    <label>Recipient Email<span class="text-danger">*</span></label>
                                    <input
                                        v-model="form.recipient_email"
                                        type="email"
                                        class="form-control"
                                        placeholder="Recipient Email Address"
                                        required
                                    >
                                    <div v-if="form.errors.recipient_email" class="text-danger text-small">
                                        {{ form.errors.recipient_email }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mt-1">
                            <Link :href="route('admin.giftcards.index')" class="btn btn-outline-secondary mr-sm-1 mb-1 mb-sm-0">
                                Cancel
                            </Link>
                            <button type="submit" class="btn btn-primary glow mb-1 mb-sm-0" :disabled="saving">
                                Save
                                <i v-if="saving" class="fa fa-spinner fa-spin"></i>
                            </button>
                        </div>
                    </form>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout';
import { Link } from '@inertiajs/vue2';

export default {
    metaInfo: { title: 'Edit Giftcard' },
    layout: Layout,
    components: { Link },
    props: {
        giftcard: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            saving: false,
            form: this.$inertia.form({
                recipient_email: this.giftcard.recipient_email,
            }),
        };
    },
    methods: {
        formatAmount(value) {
            return '₦' + Number(value ?? 0).toLocaleString();
        },
        save() {
            this.saving = true;
            this.form.put(route('admin.giftcards.update', this.giftcard.id), {
                preserveScroll: true,
                onFinish: () => {
                    this.saving = false;
                },
            });
        },
    },
};
</script>
